import { Injector } from "@angular/core";
import { QueryNode } from "../QueryNode";
import { SectionService } from "../../../service/section-service/section-service";
import { Art57Section } from "../../Art57Section/Art57Section";
import { Art57NodeUtils } from "../Art57Node/Art57NodeUtils";
import { BaseNode } from "../BaseNode";
import { ResultList } from "../ListEntity/ResultList";
import { PaginationControl } from "../../PaginationControl";
import { environment } from "../../../../../environments/environment";
import { QueryOperation } from "../../QueryOperation";

export class QueryNodeMessageBox extends QueryNode {

  paginationControl?: PaginationControl;
  constructor(injector: Injector, data: any, labelTemplate: string, entityName: string, serviceName: string) {
    super(injector, data, labelTemplate, [], [], entityName, serviceName, null);
    this.children = []; // remove querynode class specific nodes, when finish QueryConditionNodeInbox/Outbox will use query conditionsNode instead QueryConditionNodeInbox
  }

  override reset() {
    super.reset();
    this.children?.forEach(child => child.children = []);
  }

  override processResult(pageToRetrieve: PaginationControl, nodeRequest: BaseNode, data: any): void {

    let queryNode = nodeRequest;
    queryNode = (Art57NodeUtils.findFirstCurrentOrParentNodeOfType(queryNode, QueryNode) as QueryNode);

    let resultNodeList: ResultList | null = (Art57NodeUtils.findFirstChildNodeOfType(queryNode, ResultList) as ResultList);
    let resultNode = null;
    if (resultNodeList) {
      resultNode = resultNodeList.addResult(nodeRequest, pageToRetrieve, data, resultNodeList);

      if (resultNode && resultNode.data.model && resultNode.data.model.length > 0) {
        this.ioc!.get(SectionService).selectNode(resultNode as BaseNode);
      }
    }
  }

  getRecordsToExcel(pageToRetrieve: any, operation: string, isExport: boolean) {
    this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Exporting records to Excel file...', life: environment.successElapsedTime });

    if (pageToRetrieve == null) {
      const fields = this.getFields();
      const criteria = this.getConditions();
      pageToRetrieve = new PaginationControl();
      pageToRetrieve.setFields(fields);

      if (!(this.ioc!.get(Art57Section).webtrader.selectedNode.constructor.name === '_QueryNodeInBox' ||
        this.ioc!.get(Art57Section).webtrader.selectedNode.constructor.name === '_QueryNodeOutBox' ||
        this.ioc?.get(Art57Section).webtrader.selectedNode.constructor.name === '_QueryNodeToEudravigilance' ||
      this.ioc?.get(Art57Section).webtrader.selectedNode.constructor.name === '_QueryNodeFromEudravigilance')) {
        pageToRetrieve.setCriteria(criteria);
      }

    }

    this.service.filterToExcel(this.entityName, pageToRetrieve.criteria, pageToRetrieve.currentPage, false, isExport, pageToRetrieve.fields)
      .subscribe((blob: any) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'export-' + this.getDate() + '.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Exporting records to Excel finished', life: environment.successElapsedTime });
      }, (error: any) => {
        this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
      });


  }

  executeQueryToExcel() {
    this.getRecordsToExcel(null, QueryOperation.query, false);
  }

  exportToExcel() {
    this.getRecordsToExcel(null, QueryOperation.query, true);
  }

  getDate(): string {
    const date = new Date();

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hour = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${year}-${month}-${day}+${hour}.${minutes}.${seconds}`;
  }


}